function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 43,
  height: 43,
  fill: "#E5E5E5"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1980,
  height: 1210,
  transform: "translate(-1560 -65)",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 43,
  height: 43,
  rx: 4,
  fill: "#2F68CA"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.287 26.6659L27.8182 24.3221C27.5846 24.2225 27.3249 24.2015 27.0783 24.2623C26.8318 24.3231 26.6116 24.4623 26.451 24.659L24.0291 27.618C20.2281 25.8259 17.1692 22.767 15.3771 18.966L18.3361 16.5441C18.5332 16.3838 18.6727 16.1636 18.7335 15.9169C18.7943 15.6702 18.7731 15.4105 18.673 15.1769L16.3292 9.70807C16.2194 9.45631 16.0252 9.25076 15.7801 9.12685C15.5349 9.00295 15.2543 8.96847 14.9864 9.02934L9.90822 10.2012C9.65 10.2609 9.41961 10.4063 9.25466 10.6137C9.08971 10.8211 8.99994 11.0783 9 11.3433C9 23.868 19.1515 34 31.6566 34C31.9217 34.0002 32.1791 33.9104 32.3866 33.7455C32.5941 33.5805 32.7396 33.3501 32.7992 33.0918L33.9711 28.0136C34.0316 27.7444 33.9964 27.4626 33.8715 27.2167C33.7467 26.9707 33.54 26.7759 33.287 26.6659Z",
  fill: "white"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.ba35699f.svg";
export { ForwardRef as ReactComponent };